import * as z from 'zod';
import moment, { type Moment } from 'moment';

export const MomentSchema = z.custom<Moment>((data) => moment.isMoment(data), {
  message: 'Invalid Moment object',
});

export const isoDateTimeToMoment = z.codec(
  z.iso.datetime({ offset: false }),
  MomentSchema,
  {
    encode: (value: Moment): string => value.toISOString(false),
    decode: (value: string): Moment => moment(value, true),
  },
);
